import { useState } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';

export default function KartaPobytuNew() {
  const { t } = useI18n();
  const [formData, setFormData] = useState({
    company_id: '',
    permit_type: '',
    basis: '',
    full_name: '',
    passport_number: '',
    pesel: '',
    address: '',
    employer_name: '',
    employer_nip: '',
    employer_address: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  async function handleSubmit() {
    setLoading(true);
    setMessage('');
    try {
      const response = await api.post('/karta-pobytu/', formData);
      setMessage(`✅ Заявка создана с ID: ${response.data.id}`);
    } catch (error) {
      setMessage('❌ Ошибка при создании заявки');
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <Loading text="Создание заявки..." />;

  return (
    <div>
      <h1>Новая заявка на карту побыту</h1>
      {/* Add form inputs here */}
      <button onClick={handleSubmit}>Создать заявку</button>
      {message && <p>{message}</p>}
    </div>
  );
}